import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLUE_500, InfoIcon, InfoTag, Tooltip, Typography, getTestId } from '@airtel/air-design-system';
import { useState } from 'react';
import { View, Pressable } from 'react-native';
import { ButtonWidget } from '../../../button-widget';
import { TEXT_TYPE } from '../../InfoSummaryWidgetConstants';
import { getTitleTabStyles } from './TitleTabStyles';
export var TitleTab = props => {
  var _a, _b, _c;
  var singleCardDetails = props.singleCardDetails,
    isMobileScreen = props.isMobileScreen,
    _props$infoIconToolTi = props.infoIconToolTipPropTypes,
    infoIconToolTipPropTypes = _props$infoIconToolTi === void 0 ? {} : _props$infoIconToolTi,
    onUserAction = props.onUserAction;
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowTooltip = _useState[1];
  var _ref = (_a = singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoTagHeaderProps) !== null && _a !== void 0 ? _a : {},
    subType = _ref.subType,
    text = _ref.text,
    iconName = _ref.iconName,
    iconPosition = _ref.iconPosition;
  var titleTabStyles = getTitleTabStyles();
  var onInfoIconPress = () => {
    setShowTooltip(prev => !prev);
  };
  return _jsxs(View, Object.assign({
    style: [titleTabStyles === null || titleTabStyles === void 0 ? void 0 : titleTabStyles.headerWrapper, !((singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.titleText) || (singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoIconProps)) && ((singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.wrapperStyle) || (titleTabStyles === null || titleTabStyles === void 0 ? void 0 : titleTabStyles.headerWrapperNullStartElement))]
  }, {
    children: [((singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.titleText) || (singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoIconProps)) && _jsxs(View, Object.assign({
      style: titleTabStyles === null || titleTabStyles === void 0 ? void 0 : titleTabStyles.titleTextIconWrapper
    }, {
      children: [!!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.titleText) && _jsx(View, Object.assign({
        style: titleTabStyles === null || titleTabStyles === void 0 ? void 0 : titleTabStyles.titleTextContainer
      }, {
        children: _jsx(Typography, Object.assign({
          text: singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.titleText,
          color: BLACK_700,
          type: isMobileScreen ? TEXT_TYPE.TITLE_SINGLE_LINE_LG : TEXT_TYPE.TITLE_SINGLE_LINE_XL
        }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'titleText')))
      })), !!((_b = singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoIconProps) === null || _b === void 0 ? void 0 : _b.showIcon) && _jsx(Tooltip, Object.assign({
        isVisible: showToolTip,
        style: titleTabStyles.titleToolTip
      }, infoIconToolTipPropTypes, {
        onClose: onInfoIconPress
      }, {
        children: _jsx(Pressable, Object.assign({
          onPress: onInfoIconPress
        }, {
          children: _jsx(InfoIcon, Object.assign({
            color: BLUE_500,
            fontSize: 20
          }, singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoIconProps))
        }))
      }))]
    })), (singleCardDetails.infoTagHeaderProps || (singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.tertiaryCTAProps)) && _jsxs(View, Object.assign({
      style: titleTabStyles === null || titleTabStyles === void 0 ? void 0 : titleTabStyles.headerOneInfoCTAWrapper
    }, {
      children: [!!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoTagHeaderProps) && _jsx(View, Object.assign({
        style: titleTabStyles === null || titleTabStyles === void 0 ? void 0 : titleTabStyles.headerOneInfoWrapper
      }, {
        children: _jsx(InfoTag, Object.assign({
          subType: subType,
          text: text,
          iconName: iconName,
          iconPosition: iconPosition,
          size: isMobileScreen ? TEXT_TYPE.MD : TEXT_TYPE.LG
        }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'infoTagHeaderProps')))
      })), !!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.tertiaryCTAProps) && _jsx(ButtonWidget, {
        onUserAction: onUserAction,
        leftCta: Object.assign({
          testId: (props === null || props === void 0 ? void 0 : props.testID) + '_tertiaryCTAProps'
        }, singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.tertiaryCTAProps),
        onLeftCtaPress: (_c = singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.tertiaryCTAProps) === null || _c === void 0 ? void 0 : _c.onLeftCtaPress
      })]
    }))]
  }));
};
export default TitleTab;